module.exports = __webpack_public_path__ + "static/media/medicare-card-sample-outline.c4efafe0.jpg";